import classNames from 'classnames'

export interface SkeletonProps {
  className?: string
}

export function Skeleton({ className = 'w-10 h-4' }: SkeletonProps) {
  return (
    <div
      className={classNames(
        className,
        'rounded-md bg-zinc-300 dark:bg-zinc-700 shimmer min-w-[8px] min-h-[8px]'
      )}
    ></div>
  )
}
